export default __webpack_public_path__ + "static/media/Clima_Tempo.78fa58c1.png";